export default __webpack_public_path__ + "static/media/ic_close_red.9b58f2e8.svg";